<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useLogger } from 'vue-logger-plugin'
import { useRoute, useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'

import AppBarAccountMenu from '@/components/AppBarAccountMenu.vue'
import AppBarHamburger from '@/components/AppBarHamburger.vue'
import GenderedLogo from '@/components/GenderedLogo.vue'
import { useUtil } from '@/composables/util'
import {
  ROUTE_ADMIN,
  ROUTE_CUSTOMIZE,
  ROUTE_LEGACY,
  ROUTE_MY_RECORDINGS,
  ROUTE_PRACTICE,
  ROUTE_RECORDINGS,
  ROUTE_STUDENT_RECORDINGS,
  ROUTE_STUDENTS,
} from '@/constants/appConstants'

const STUDENT_TABS = [
  { label: 'Practice', path: ROUTE_PRACTICE },
  { label: 'Legacy', path: ROUTE_LEGACY },
  { label: 'Recordings', path: ROUTE_MY_RECORDINGS },
]

const TEACHER_TABS = [
  { label: 'Recordings', path: ROUTE_RECORDINGS },
  { label: 'Customize', path: ROUTE_CUSTOMIZE },
  { label: 'Students', path: ROUTE_STUDENTS },
  { label: 'Homework', path: ROUTE_LEGACY },
  { label: 'Student Recordings', path: ROUTE_STUDENT_RECORDINGS },
]

const ADMIN_TAB = { label: 'Admin', path: ROUTE_ADMIN }

const logger = useLogger()
const { isStaff, isStudent, loginCheck } = useUtil(logger)
const route = useRoute()
const router = useRouter()
const { mdAndUp } = useDisplay()

const visibleTabs = computed(() => {
  const baseTabs = isStudent() ? STUDENT_TABS : TEACHER_TABS
  return isStaff() ? [...baseTabs, ADMIN_TAB] : baseTabs
})
const activeTab = computed(() => visibleTabs.value.find((t) => route.path.startsWith(t.path))?.path)

onMounted(() => {
  loginCheck()
})
</script>

<template>
  <v-app-bar app color="primary">
    <gendered-logo :force-dark="true" />
    <template v-if="mdAndUp">
      <v-divider class="ma-0 mx-4 pa-0 divider-on-dark" vertical></v-divider>
      <v-tabs align-with-title :model-value="activeTab">
        <v-tab v-for="tab of visibleTabs" :key="tab.path" :value="tab.path" @click="router.push(tab.path)">{{ tab.label }}</v-tab>
      </v-tabs>
      <v-spacer />
      <app-bar-account-menu />
    </template>
    <template v-else>
      <v-spacer />
      <app-bar-hamburger :tabs="visibleTabs" />
    </template>
  </v-app-bar>
</template>

<style scoped>
:deep(.v-tab) {
  color: rgba(255, 255, 255, 0.7) !important;
}
:deep(.v-tab--selected),
:deep(.v-tab:hover) {
  color: #fff !important;
}
:deep(.v-tab--selected .v-tab__slider) {
  color: #fff !important;
}
.divider-on-dark {
  border-color: rgba(255, 255, 255, 0.3) !important;
}
</style>
